import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPage.css';

export default function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div className="static-page">
      <div className="static-nav">
        <button className="static-back" onClick={() => navigate(-1)}>← Back</button>
        <span className="static-nav-logo display-font">World Cup Pick'em</span>
      </div>
      <div className="static-content">
        <h1>Privacy Policy</h1>
        <p className="static-updated">Last updated: March 27, 2026</p>

        <h2>1. Information We Collect</h2>
        <p>We collect the following information when you use the Service:</p>
        <ul>
          <li><strong>Account data:</strong> username, email address</li>
          <li><strong>Usage data:</strong> picks you make, leagues you join or create, leaderboard standings</li>
          <li><strong>Preferences:</strong> dark mode setting</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use collected information to:</p>
        <ul>
          <li>Operate and maintain the Service (authentication, scoring, leaderboards)</li>
          <li>Send transactional emails (league invites, password reset) via Resend</li>
          <li>Improve the Service and diagnose issues</li>
        </ul>
        <p>We do not sell your personal information to third parties.</p>

        <h2>3. Data Storage</h2>
        <p>Your data is stored in Google Firebase (Firestore and Firebase Authentication), which is hosted in the United States. By using the Service, you consent to this storage location.</p>

        <h2>4. Emails</h2>
        <p>We send emails only for: (a) league invitations you explicitly trigger, and (b) password reset requests you initiate. We do not send marketing or promotional emails.</p>

        <h2>5. Cookies and Tracking</h2>
        <p>The Service uses Firebase Authentication, which stores session tokens in your browser's local storage to keep you signed in. We do not use third-party advertising cookies in the authenticated app.</p>
        <p>The public landing page may in the future include Google AdSense, which uses cookies for ad personalization. This will be disclosed when implemented.</p>

        <h2>6. Data Sharing</h2>
        <p>We share data only with the following service providers, solely to operate the Service:</p>
        <ul>
          <li><strong>Google Firebase</strong> — authentication and database</li>
          <li><strong>Resend</strong> — transactional email delivery</li>
          <li><strong>Netlify</strong> — hosting and serverless functions</li>
        </ul>

        <h2>7. Your Rights</h2>
        <p>You may delete your account at any time from the league selector screen. Deleting your account removes your personal data and all associated picks from the Service, subject to the 48-hour grace period if you are a league commissioner.</p>

        <h2>8. Children's Privacy</h2>
        <p>The Service is not directed to children under 13. We do not knowingly collect personal information from children under 13.</p>

        <h2>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will note the date of the last update at the top of this page.</p>

        <h2>10. Contact</h2>
        <p>Questions about this Privacy Policy can be directed to the platform administrator.</p>
      </div>
    </div>
  );
}
